/**
 * Runtime configuration shim.
 *
 * Values that differ per cluster/overlay are injected at container start into
 * `window.__ENV__` by `/env.js` (generated by frontend/generate-env-js.sh from
 * the container environment). Reading them here ÔÇö instead of
 * `process.env.REACT_APP_*` baked at build time ÔÇö lets a single
 * `hub360-core-frontend` image serve every environment
 * (see presentations/core-release-artifacts.md).
 *
 * Fallback order: window.__ENV__ (runtime) -> process.env (build-time / dev).
 * Empty or un-substituted `__PLACEHOLDER__` values are treated as unset, so the
 * CRA dev server and legacy per-cluster images keep working unchanged.
 */

const runtimeEnv =
  (typeof window !== 'undefined' && window.__ENV__) || {};

function resolve(runtimeKey, buildValue, fallback = '') {
  const raw = runtimeEnv[runtimeKey];
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed && !/^__.*__$/.test(trimmed)) {
      return trimmed;
    }
  }
  const built = (buildValue || '').trim();
  return built || fallback;
}

// wes-ai voice WebSocket base URL (e.g. wss://ai.hub360.1wes.com). Per-cluster ÔÇö
// the one value that used to force a per-cluster frontend build.
export const WES_AI_WS_URL = resolve(
  'WES_AI_WS_URL',
  process.env.REACT_APP_WES_AI_WS_URL
);

export const PRODUCT_NAME = resolve(
  'PRODUCT_NAME',
  process.env.REACT_APP_PRODUCT_NAME,
  'Hub360'
);

export const PUBLIC_BASE_URL = resolve(
  'PUBLIC_BASE_URL',
  process.env.REACT_APP_PUBLIC_BASE_URL
);

export const IDP_EMBED_URL = resolve(
  'IDP_EMBED_URL',
  process.env.REACT_APP_IDP_EMBED_URL
);

// Seletor de cenario da demonstracao. Vive aqui, e nao em
// `process.env.REACT_APP_*`, pelo motivo que custou a descoberta: como flag de
// build ela dependia de alguem passar a variavel no `npm run build`, e ninguem
// passava — nem no Dockerfile, nem no pipeline. O componente viajava no bundle
// como codigo morto em todo ambiente, enquanto as chaves de mesmo nome no
// backend ja respondiam. Sendo de runtime, as duas pontas ligam e desligam
// pelo mesmo configmap.
export const WES_IDENTITY_DEMO = resolve(
  'WES_IDENTITY_DEMO',
  process.env.REACT_APP_WES_IDENTITY_DEMO
);

const runtimeConfig = {
  WES_AI_WS_URL,
  PRODUCT_NAME,
  PUBLIC_BASE_URL,
  IDP_EMBED_URL,
  WES_IDENTITY_DEMO,
};

export default runtimeConfig;
